import { Button, Modal } from 'react-bootstrap';

import CaseAuditTable from '../../case/audit/CaseAuditTable';
import { useGetCaseAuditLogs } from '../../case/audit/useGetCaseAuditLog';

export interface ICaseAuditControlProps {
    onCancel: () => void;
    open: boolean;
    params: {
        caseGuid: string;
    };
    title: string;
}

export function CaseAuditControl(props: ICaseAuditControlProps) {
    const caseAuditApi = useGetCaseAuditLogs(props.params.caseGuid);

    return (
        <Modal centered show={props.open} size="xl" scrollable>
            <Modal.Header>
                <Modal.Title>{props.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {caseAuditApi.isFetching || !caseAuditApi.data ? (
                    <>Loading...</>
                ) : (
                    <CaseAuditTable results={caseAuditApi.data} />
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="dark" onClick={props.onCancel}>
                    OK
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
